import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from 'lucide-react';

import { Button } from '../ui/button.jsx';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select.jsx';

export function DataTableFooter({
  table,
  pageSize = [50, 100],
  rowsName = 'linhas',
  hide = {
    selectedRows: false,
    skipAll: false,
  },
}) {
  return table.getRowModel().rows?.length ? (
    <div className="flex flex-col items-start gap-y-2.5 md:flex-row md:items-center md:justify-between md:gap-y-0">
      {/*  */}
      {!hide.selectedRows && (
        <div className="text-sm text-muted-foreground">
          {table.getFilteredSelectedRowModel().rows.length} de{' '}
          {table.getFilteredRowModel().rows.length} {rowsName} selecionadas.
        </div>
      )}

      <p className="text-sm text-muted-foreground">
        Página <b>{table.getState().pagination.pageIndex + 1}</b> de{' '}
        <b>{table.getPageCount().toLocaleString()}</b>
      </p>

      <div className="flex items-center space-x-3">
        <Select
          onValueChange={(val) => {
            table.setPageSize(Number(val));
          }}
          defaultValue={table.getState().pagination.pageSize}
        >
          <SelectTrigger className="h-9 w-[125px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {pageSize.map((pageSize) => (
              <SelectItem key={pageSize} value={pageSize}>
                {pageSize} {rowsName}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {!hide.skipAll && (
          <Button
            variant="outline"
            className="hidden size-9 p-0 lg:flex"
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
          >
            <span className="sr-only">Primeira Página</span>
            <ArrowLeftIcon className="size-4" />
          </Button>
        )}
        <Button
          variant="outline"
          className="size-9 p-0"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          <span className="sr-only">Página Anterior</span>
          <ChevronLeftIcon className="size-4" />
        </Button>

        <Button
          variant="outline"
          className="size-9 p-0"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          <span className="sr-only">Próxima Página</span>
          <ChevronRightIcon className="size-4" />
        </Button>
        {!hide.skipAll && (
          <Button
            variant="outline"
            className="hidden size-9 p-0 lg:flex"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            <span className="sr-only">Última Página</span>
            <ArrowRightIcon className="size-4" />
          </Button>
        )}
      </div>
    </div>
  ) : null;
}
